module.exports = __webpack_public_path__ + "img/business-characteristics.8c53f29e.png";